import { z } from 'zod';
export const VendorNameSchema = z.enum(['Verisk', 'Cotality', 'Guidewire']);
export const VendorNameEnum = VendorNameSchema.enum;
